import { print } from 'graphql';
import { gql } from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { defaultDoc } from '../share/defaultDoc';

export interface RepairFactor {
  readonly name: string;
  readonly id: string;
  readonly discipline: number;
  readonly sort: number;
  readonly isActive: boolean;
  readonly dateModified: string;
}

export const repairFactorSchema: RxJsonSchema<RepairFactor> = {
  type: 'object',
  version: 0,
  description: 'describes repair Factor',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    discipline: { type: ['number', 'null'] },
    sort: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};

export type RepairFactorCollection = RxCollection<RepairFactor> | null;
export type RepairFactorDocument = RxDocument<RepairFactor>;

export const repairFactorPullQueryBuilder = (document: RepairFactor) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query repairFactorFeed($lastRequested: DateTime) {
      repairFactorFeed(lastRequested: $lastRequested) {
        name
        id
        discipline
        sort
        isActive
        dateModified
      }
    }
  `);

  return {
    query,
    variables: { lastRequested: doc?.dateModified },
  };
};

export default {};
